import React, { useEffect, useState,useCallback } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  IconButton,
    Select,
    FormControl,
    MenuItem,
    InputLabel
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { getCategories, getSubcategoriesSearch, saveSubcategories, updateSubcategories, deleteSubcategories} from '../service/commonService';

export default function SubCategoryManager() {
  const [subCategories, setSubCategories] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [filter, setFilter] = useState("");
     const [categories, setCategories] = useState([]);
  const [paginationModel, setPaginationModel] = useState({ 
        page: 0, 
        pageSize: 5 
    });
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    subCategoryId: "",
    name: "",
    description: "",
    categoryId: ""
  });
  
      
const fetchSubCategories = useCallback(async (page, pageSize, search) => {
        setIsLoading(true);
        try {
            // Send pagination and search filter as query parameters
            const response = await getSubcategoriesSearch(page,pageSize, search)
            
            // The backend returns a PageResponse (content, totalElements, totalPages, etc.)
            const data = response.data;
            console.log("totalelement ", data.totalElements);
            setSubCategories(data.content);
            setTotalRowCount(data.totalElements); // Crucial for DataGrid total count
            
        } catch (error) {
            console.error("Error fetching subcategories:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

  useEffect(() => {
        loadData();
    fetchSubCategories(paginationModel.page, paginationModel.pageSize, filter);

  }, [paginationModel, filter, fetchSubCategories]);

  const loadData = async () => {
        const catRes = await getCategories(); 
    setCategories(catRes.data);  
    };

  
  // --- Handler for Filter Input Change ---
    const handleFilterChange = (event) => {
        const newFilter = event.target.value;
        setFilter(newFilter);
        // Reset to page 0 when the filter changes to ensure consistent results
        setPaginationModel(prev => ({ ...prev, page: 0 }));
    };

  const handleOpenDialog = (subCategory = null) => {
    setSelectedSubCategory(subCategory);
    if (subCategory) {
      setFormData({ ...subCategory,
                category: {
          categoryId: subCategory.categoryId,
        }});
    } else {
      setFormData({ subCategoryId: "", name: "", description: "",
      categoryId: ""
  });
    } 
    setOpenDialog(true);
  }; 

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleSave = async () => {
    try {
        
         if (
    !formData.name ||
    !formData.description ||
    !formData.categoryId 
  ) {
    alert("Please fill in all required fields.");
    return;
  }
        
      if (formData.subCategoryId) {
        // Update
        await updateSubcategories(formData.subCategoryId, formData);
      } else {
        // Create
        await saveSubcategories(formData); 
      }
      fetchSubCategories();
      handleCloseDialog();
    } catch (error) {
      console.error("Error saving SubCategory:", error);
    }
  };
    
    
  const handleChange = (e) => {
    // Corrected onChange handler
    setFormData((prev) => {
      // Ensure 'prev' and 'prev.category' exist before destructuring
      const prevCategory = prev?.category || {};
      return {
        ...prev,
        category: {
          ...prevCategory,
          categoryId: e.target.value,
        },
      };
    });
      
      alert(formData.category.categoryId
           );
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this SubCategory?")) {
      try {
        await deleteSubcategories(id); 
        fetchSubCategories();
      } catch (error) {
        console.error("Error deleting SubCategory:", error);
      }
    }
  };

  const columns = [
    { field: "subCategoryId", headerName: "ID", width: 90 },
    { field: "name", headerName: "Name", width: 200 },
    { field: "description", headerName: "Description", flex: 1 },
    { field: "categoryName", headerName: "Category Name", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      sortable: false,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleOpenDialog(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="secondary" onClick={() => handleDelete(params.row.subCategoryId)}>
            <Delete />
          </IconButton>
          <IconButton onClick={() => alert(JSON.stringify(params.row, null, 2))}>
            <Visibility />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        SubCategory Management
      </Typography>

      {/* Filter Input */}
      <TextField
        label="Search..."
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 2 }}
        value={filter}
        onChange={handleFilterChange}
      />

      {/* Add Button */}
      <Button variant="contained" color="primary" onClick={() => handleOpenDialog()} sx={{ mb: 2 }}>
        Add SubCategory
      </Button>

      {/* DataGrid */}
      <div style={{ height: 400, width: "100%" }}>
  <DataGrid
    pagination
    paginationMode="server"
    rows={subCategories}
    columns={columns}
    rowCount={totalRowCount}
    page={paginationModel.page}
    pageSize={paginationModel.pageSize}
    onPageChange={(newPage) => {
      console.log("Page changed:", newPage);
      setPaginationModel((prev) => ({ ...prev, page: newPage }));
    }}
    onPageSizeChange={(newPageSize) => {
      console.log("Page size changed:", newPageSize);
      setPaginationModel((prev) => ({ ...prev, pageSize: newPageSize, page: 0 }));
    }}
    rowsPerPageOptions={[5, 10, 20]} // ✅ correct prop for v5
    loading={isLoading}
    getRowId={(row) => row.subCategoryId}
    disableColumnFilter
    disableColumnSorting
  />

      </div>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>{formData.subCategoryId ? "Edit SubCategory" : "Add SubCategory"}</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            label="Name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            fullWidth
              required
          />
          <TextField
            label="Description"
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            fullWidth
            multiline
            rows={3}
            required
          />
           <FormControl fullWidth margin="dense">
        <InputLabel>Category</InputLabel>
        <Select
          label="Category"
          name="categoryId"
          value={formData?.categoryId || ''}
          onChange={(e) => setFormData({ ...formData, categoryId: e.target.value })}
            required
        >
          {categories.map((sc) => (
            <MenuItem key={sc.categoryId} value={sc.categoryId}>
              {sc.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
